const mEditionBillingAcademyClientsSales = {
  mEditionBillingAcademyClientsSales: {
    alerts: {
      readAcademy: {
        error: 'Error al intentar buscar datos de la academia.'
      },

      readVentasExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de ventas descargado.'
      }
    },

    buttonPrimary: 'Descargar CSV',

    content: {
      academy: 'Academia',
      name: 'Nombre Cliente',
      eur: 'EUR',
      usd: 'USD',
      ars: 'ARS',
      mxn: 'MXN',
      lastPayment: 'Último pago',
      products: 'Productos'
    },

    files: {
      sales: 'ventas'
    },

    free: 'Gratis',

    table: {
      thConcept: 'Detalle',
      thClient: 'Cliente',
      thDate: 'Fecha',
      thDiscount: 'Desc.',
      thMethod: 'Medio',
      thRecord: 'Ver',
      thToPay: 'A Pagar',
      thTotal: 'Total'
    }
  }
}

export default mEditionBillingAcademyClientsSales
